import { render, staticRenderFns } from "./VolumeIcon.vue?vue&type=template&id=195a8b86&scoped=true&"
import script from "./VolumeIcon.vue?vue&type=script&lang=js&"
export * from "./VolumeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a8b86",
  null
  
)

export default component.exports